import { useEffect } from "react";
import { useRouter } from "next/router";
import NextLink from "next/link";
import {
  Button,
  Icon,
  Link,
  List,
  ListItem,
  SimpleGrid,
} from "@chakra-ui/react";
import { AiFillFolderOpen, AiFillFolder } from "react-icons/ai";
import { gql } from "__generated__/gql";
import { useQuery } from "utils/apollo/hooks";

const allFoldersQuery = gql(/* GraphQL */ `
  query DocumentFolders {
    allDocumentFolders: documentFoldersList(orderBy: NAME_ASC) {
      slug
      name
    }
  }
`);

export default function DocumentFolders() {
  const { pathname, query, replace, isReady } = useRouter();
  const { data } = useQuery(allFoldersQuery);

  useEffect(() => {
    if (isReady && !query.folder && data?.allDocumentFolders?.[0]) {
      replace({
        pathname,
        query: { ...query, folder: data?.allDocumentFolders[0]?.slug },
      }).catch(console.error);
    }
  }, [data?.allDocumentFolders, isReady, pathname, query, replace]);

  return (
    <SimpleGrid as={List} minChildWidth="10rem" spacing=".25rem">
      {(data?.allDocumentFolders || []).map((folder) => {
        const isActive = folder.slug === query.folder;
        return (
          <ListItem key={folder.slug}>
            <NextLink
              href={{ pathname, query: { ...query, folder: folder.slug } }}
              passHref
              legacyBehavior
            >
              <Button
                as={Link}
                aria-current={isActive ? "page" : undefined}
                sx={{
                  ".chakra-button__icon": {
                    color: "softBlue",
                  },
                }}
                leftIcon={
                  <Icon
                    as={isActive ? AiFillFolderOpen : AiFillFolder}
                    boxSize="2em"
                  />
                }
                size="sm"
                iconSpacing=".75em"
                justifyContent="flex-start"
                backgroundColor="lightBlueGrey"
                color="black"
                fontWeight={400}
                margin={0}
                padding=".5em 1em"
                width="100%"
                whiteSpace="normal"
                lineHeight={1.2}
                height="auto"
                minHeight="4em"
                borderRadius={10}
                textTransform="none"
                _hover={{ textDecoration: "none" }}
                _activeLink={{
                  color: "white",
                  background: "magenta.dark",
                  ".chakra-button__icon": {
                    color: "lightBlueGrey",
                  },
                }}
              >
                {folder.name}
              </Button>
            </NextLink>
          </ListItem>
        );
      })}
    </SimpleGrid>
  );
}
